import { render, staticRenderFns } from "./ReservationEventList.vue?vue&type=template&id=0b9474b4"
import script from "./ReservationEventList.vue?vue&type=script&lang=js"
export * from "./ReservationEventList.vue?vue&type=script&lang=js"
import style0 from "./ReservationEventList.vue?vue&type=style&index=0&id=0b9474b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports